import { HStack, VStack, Text, Button } from "@chakra-ui/react";
import { ReactNode } from "react";

interface RebateHeaderProps {
  title?: string;
  description?: string;
  actions?: ReactNode;
}

export const RebateHeader = ({
  title = "Rebates",
  description = "Applied to all active ticket types",
  actions,
}: RebateHeaderProps) => {
  return (
    <HStack justify="space-between" align="flex-start">
      <VStack align="flex-start" spacing={1}>
        <Text fontSize="lg" fontWeight="bold">
          {title}
        </Text>
        <Text fontSize="sm" color="gray.500">
          {description}
        </Text>
      </VStack>
      {actions && <HStack spacing={2}>{actions}</HStack>}
    </HStack>
  );
};
